import { FinalDocument as IFinalDocument } from "@/api/models/final-document";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import { EducationProtocol as IEducationProtocol } from "@/api/models/education-protocol";
import router from "@/router";
import finalDocuments, {
  FinalDocumentParams
} from "@/getinfo-api/final-document";
import api from "@/getinfo-api";
import mutations from "@/store/modules/mutations";

export default {
  namespaced: true,
  state: {
    protocolForCreateDocument: {},
    listenerForCreateDocument: {},
    selectedFinalDocument: {},
    list: [] as Array<IFinalDocument>,
    count: 0,
    limit: 30,
    offset: 0
  },
  actions: {
    async LIST(ctx: any, params: FinalDocumentParams) {
      let myParams: FinalDocumentParams = {
        ...params,
        limit: ctx.state.limit,
        offset: ctx.state.offset
      };
      try {
        let response = await finalDocuments(myParams);
        ctx.commit("ADD_TO_LIST", response.data.items);
        ctx.commit("SET_COUNT", response.data.count);
        ctx.commit("INCREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    async REMOVE(ctx: any, id: string) {
      try {
        await api.FinalDocumentApi._delete(id);
        ctx.commit("REMOVE_FROM_LIST", id);
        ctx.commit("DECREASE_COUNT");
        ctx.commit("DECREASE_OFFSET");
      } catch (e) {
        await ctx.dispatch(
          "errorException",
          {
            vm: this,
            error: e.response
          },
          { root: true }
        );
      }
    },
    SETUP_SELECTED_FINAL_DOCUMENT(ctx: any, finalDocument: IFinalDocument) {
      ctx.commit("SETUP_SELECTED_FINAL_DOCUMENT", finalDocument);
    },
    GO_TO_FINAL_DOCUMENT_PAGE(ctx: any, finalDocument: IFinalDocument) {
      ctx.commit("SETUP_SELECTED_FINAL_DOCUMENT", finalDocument);
      router.push({
        name: "finalDocument",
        params: {
          id: finalDocument.id
        }
      });
    }
  },
  mutations: {
    ...mutations.mutations,
    SETUP_SELECTED_FINAL_DOCUMENT(state: any, finalDocument: IFinalDocument) {
      state.selectedFinalDocument = finalDocument;
    },
    SETUP_LISTENER_FOR_CREATE_DOCUMENT(state: any, listener: ICourseListener) {
      state.listenerForCreateDocument = listener;
    },
    SETUP_PROTOCOL_FOR_CREATE_DOCUMENT(
      state: any,
      protocol: IEducationProtocol
    ) {
      state.protocolForCreateDocument = protocol;
    },
    CLEAR_CREATE_FINAL_DOCUMENT_FROM_STATE(state: any) {
      state.protocolForCreateDocument = {};
      state.listenerForCreateDocument = {};
    }
  },
  getters: {
    SELECTED_FINAL_DOCUMENT(state: any) {
      return state.selectedFinalDocument;
    },
    PROTOCOL_FOR_CREATE_DOCUMENT(state: any) {
      return state.protocolForCreateDocument;
    },
    LISTENER_FOR_CREATE_DOCUMENT(state: any) {
      return state.listenerForCreateDocument;
    },
    GET_LIST(state: any) {
      return state.list;
    },
    GET_COUNT(state: any) {
      return state.count;
    }
  }
};
